import { FOOD_PAYMENT_EMOJIS } from "./donationEffects";

export const TITHE_PRESETS = Object.freeze([
  { id: "burger", amount: 0.50, emoji: "🍔" },
  { id: "fries", amount: 0.50, emoji: "🍟" },
  { id: "cookie", amount: 0.50, emoji: "🍪" },
  { id: "cake", amount: 0.50, emoji: "🍰" },
  { id: "ice-cream", amount: 0.50, emoji: "🍦" },
  { id: "donut", amount: 0.50, emoji: "🍩" },
  { id: "cherries", amount: 0.50, emoji: "🍒" },
  { id: "lollipop", amount: 0.50, emoji: "🍭" },
  { id: "one-dollar", amount: 1 },
  { id: "two-fifty", amount: 2.50 },
  { id: "five-dollars", amount: 5 },
  { id: "ten-dollars", amount: 10 },
  { id: "twenty-dollars", amount: 20 },
  { id: "fifty-dollars", amount: 50 },
  { id: "one-hundred-dollars", amount: 100 },
]);

export const PAYMENT_REACTION_EMOJIS = FOOD_PAYMENT_EMOJIS;

export const shouldPlayDollarEffect = () => true;

export const getTithePresetById = (presetId) => (
  TITHE_PRESETS.find(({ id }) => id === presetId) || TITHE_PRESETS[0]
);
